import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface DomainFormValues {
  id?: string;
  company_id: string;
  domain: string;
  country: string;
  language: string;
  active: boolean;
  display: boolean;
  tone_of_voice: string | null;
  modify_comment: string | null;
}

interface DomainDetailsFormProps {
  domain?: DomainFormValues | null;
  companyId: string;
  onClose: () => void;
  onSubmit: (domain: DomainFormValues) => Promise<void>;
  newDomain?: boolean;
}

const DomainDetailsForm = ({
  domain,
  companyId,
  onClose,
  onSubmit,
  newDomain = false,
}: DomainDetailsFormProps) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<DomainFormValues>({
    id: domain?.id || '',
    company_id: companyId,
    domain: domain?.domain || '',
    country: domain?.country || '',
    language: domain?.language || '',
    active: domain?.active || true,
    display: domain?.display || true,
    tone_of_voice: domain?.tone_of_voice || '',
    modify_comment: domain?.modify_comment || '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { ...domainToSubmit } = formData;
    await onSubmit(newDomain ? domainToSubmit : formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('domain.domain')}</label>
        <input
          type="text"
          value={formData.domain}
          onChange={(e) => setFormData({ ...formData, domain: e.target.value })}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('domain.country')}</label>
        <input
          type="text"
          value={formData.country}
          onChange={(e) => setFormData({ ...formData, country: e.target.value })}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('domain.language')}</label>
        <input
          type="text"
          value={formData.language}
          onChange={(e) => setFormData({ ...formData, language: e.target.value })}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">
          {t('domain.tone_of_voice')}
        </label>
        <textarea
          value={formData.tone_of_voice || ''}
          onChange={(e) => setFormData({ ...formData, tone_of_voice: e.target.value })}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
          rows={10}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">{t('domain.comment')}</label>
        <textarea
          value={formData.modify_comment || ''}
          onChange={(e) => setFormData({ ...formData, modify_comment: e.target.value })}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
          rows={3}
        />
      </div>
      {/* <div className="flex items-center space-x-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.active}
            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
            className="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
          <span className="ml-2 text-sm text-gray-700">{t('domain.active')}</span>
        </label>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.display}
            onChange={(e) => setFormData({ ...formData, display: e.target.checked })}
            className="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
          <span className="ml-2 text-sm text-gray-700">{t('domain.display')}</span>
        </label>
      </div> */}
      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-2 py-1 text-sm border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          {t('common.cancel')}
        </button>
        <button
          type="submit"
          className="px-2 py-1 text-sm border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          {domain ? t('common.save_changes') : t('domain.add_domain')}
        </button>
      </div>
    </form>
  );
};

export default DomainDetailsForm;
